import Index from './index.vue'
import Base from './Base.vue'
import Create from './Create.vue'
import Edit from './Edit.vue'

export default {
    Index,
    Base,
    Create,
    Edit
}


// WEBPACK FOOTER //
// ./src/views/salesman/preOrders/index.js